import { apiClient } from "./apiClient";
import { logger } from "./logger";

export interface AppConfig {
  role: "admin" | "user";
  allowed_tabs: string[];
  allowed_actions: string[];
  plan_code: string | null;
  trades_used_today: number;
  user_trading_enabled: boolean;
  has_integrations: boolean;
}

export async function getAppConfig(): Promise<AppConfig> {
  try {
    const response = await apiClient.get<AppConfig>("/app/config");
    return response.data;
  } catch (error) {
    logger.error("Error fetching app config:", error instanceof Error ? error : new Error(String(error)));
    throw error;
  }
}

